import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { SnackbarProvider } from "notistack";
import { App } from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { ProfileProvider } from "./lib/profile";
// Self-hosted Tabler icon webfont (bundled by Vite) — replaces the CDN <link>,
// which silently failed to load icons in some environments (CSP/network).
import "@tabler/icons-webfont/dist/tabler-icons.min.css";
import "./index.css";
import { applyBrainCssVars } from "./design/brainCssVars";

// Single paint path: CSS vars (--kt-*, --font-*, --color-*) come from brainTokens.
applyBrainCssVars();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <SnackbarProvider
      maxSnack={3}
      preventDuplicate
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <ErrorBoundary>
        <ProfileProvider>
          <App />
        </ProfileProvider>
      </ErrorBoundary>
    </SnackbarProvider>
  </StrictMode>
);
